export const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  appDomain: process.env.REACT_APP_URL,
  appName: process.env.REACT_APP_NAME,
  domain: process.env.REACT_APP_DOMAIN,
  imageUrl: process.env.REACT_APP_IMAGE_URL,
  videoUrl: process.env.REACT_APP_VIDEO_URL,
  logrocketId: process.env.REACT_APP_LOGROCKET_ID,
  googleAnalytics: process.env.REACT_APP_GOOGLE_ANALYTICS,
};

export const amplifyConfig = {
  Auth: {
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_USERPOOLID,
    userPoolWebClientId: process.env.REACT_APP_WEBCLIENTID,
    mandatorySignIn: false,
    cookieStorage: {
      domain: process.env.REACT_APP_DOMAIN,
      path: "/",
      expires: 30,
      secure: true,
    },
    redirectSignIn: `${process.env.REACT_APP_URL}/login`,
    redirectSignOut: `${process.env.REACT_APP_URL}/logout`,
  },
  oauth: {
    domain: process.env.REACT_APP_OAUTHDOMAIN,
    scope: ["aws.cognito.signin.user.admin"],
    redirectSignIn: `${process.env.REACT_APP_URL}/login`,
    redirectSignOut: `${process.env.REACT_APP_URL}/logout`,
    respopnseType: "code",
  },
};

export const StripeConfig = {
  PublishableKey: process.env.REACT_APP_STRIPE_PK,
};
